import { render, staticRenderFns } from "./factor-payment.vue?vue&type=template&id=395fd620&scoped=true&"
import script from "./factor-payment.vue?vue&type=script&lang=js&"
export * from "./factor-payment.vue?vue&type=script&lang=js&"
import style0 from "./factor-payment.vue?vue&type=style&index=0&id=395fd620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395fd620",
  null
  
)

export default component.exports